/* istanbul ignore file */ /* this file is not used or will be deleted in other branches */
// @ts-nocheck
import React, { CSSProperties, Fragment, useCallback, useEffect, useState } from 'react';
import _ from 'lodash';
import useFieldApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-field-api';
import useFormApi from '@data-driven-forms/react-form-renderer/dist/cjs/use-form-api';
// eslint-disable-next-line import/no-named-default
import { default as DdfFieldArray } from '@data-driven-forms/react-form-renderer/dist/cjs/field-array';
import { useDdf } from '../../context/ddf-context';
import { generateGridTemplate } from '@td-client-frontend/common';
import { GroupCodes } from '../../@types/Groups';

export interface CodeOption {
  code: string;
  bpCodes?: GroupCodes[];
  classCodes?: GroupCodes[];
  value?: string;
  label?: string;
}

function FieldSelectArray(props) {
  const { fieldKey, arrayValidator, fields, input, selectField } = useFieldApi(props);
  const { getState } = useFormApi();
  const { handlers } = useDdf();
  const { renderForm } = useFormApi();

  const style: CSSProperties = {
    gridTemplateColumns: generateGridTemplate(fields)
  };

  const data = getState();

  const evaluateCodeOptions = useCallback(() => {
    const inputHasValue: boolean = !!input.value.length && input.value[0][selectField];
    const mapInputValue = () =>
      input.value.map((item: CodeOption) => ({
        ...item,
        value: item[selectField],
        label: item[selectField],
        code: item[selectField]
      }));

    return inputHasValue ? mapInputValue() : [];
  }, [input.value, selectField]);

  const [chosenIndex, setChosenIndex] = useState<number>(0);
  const [codeOptions, setCodeOptions] = useState<CodeOption[]>(evaluateCodeOptions());
  const [initialCodeOptionsState] = useState<CodeOption[]>(codeOptions);
  const [selected, setSelected] = useState<string>(_.get(codeOptions, '[0].value', ''));

  useEffect(() => {
    codeOptions.length && setCodeOptions(evaluateCodeOptions());
    if (!selected) setSelected(_.get(codeOptions, '[0].value', ''));
    if (_.findIndex(codeOptions, { value: selected }) !== chosenIndex) setChosenIndex(0);
    if (!codeOptions.find((option) => option.value === selected)) setSelected(_.get(codeOptions, '[0].value', ''));
    if (
      (codeOptions.length && !codeOptions[chosenIndex]) ||
      _.isEqual(_.sortBy(evaluateCodeOptions()), _.sortBy(initialCodeOptionsState))
    ) {
      setChosenIndex(0);
      setSelected(_.get(codeOptions, '[0].value', ''));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data.values]);

  const changeSubForm = (value) => {
    setSelected(value);
    setChosenIndex(_.findIndex(codeOptions, { value }));
  };
  const updateOptions = (codes: CodeOption[]) => {
    input.onChange(
      codes.length
        ? codes
        : [
            {
              code: '',
              bpCodes: [],
              classCodes: []
            }
          ]
    );
    setCodeOptions(codes);
  };

  const generateFieldsArrayNames = (fieldsArr) => {
    return fieldsArr.map((field) => {
      const fieldNameArr = field.name.split('.');
      const fieldName = fieldNameArr[fieldNameArr.length - 1];
      if (field.customSelect) {
        field.options = field.options || codeOptions;
        field.onChange = changeSubForm;
        field.value = selected;

        if (field.handler && field.labelBtn) {
          field.labelBtn = () => handlers[field.handler]({ updateOptions, codeOptions, initialCodeOptionsState });
        }
      }

      return { ...field, name: `${input.name}[${chosenIndex}].${fieldName}` };
    });
  };

  return (
    <div className="col-span-12">
      <div className="grid gap-8 pl-3 -ml-3" style={style}>
        <DdfFieldArray key={fieldKey} name={input.name} validate={arrayValidator}>
          {(fieldArrayRenderProps) => (
            <Fragment>
              {
                fieldArrayRenderProps.fields.map(() => {
                  fieldArrayRenderProps.fields.value.forEach((item) => {
                    if (!item[selectField]) {
                      item[selectField] = selected;
                    }
                  });
                  return renderForm(generateFieldsArrayNames(fields));
                })[0]
              }
            </Fragment>
          )}
        </DdfFieldArray>
      </div>
    </div>
  );
}

export default FieldSelectArray;
